export interface ModuleOption {
    name: string;
    value: string;
}

export const ModulePropsOption = {
    option: { type: Array as PropType<{ name: string; value: string }[]>, default: [] },
    data: { type: Object, required: true },
    id: { type: String, default: "" },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
export const ModuleEmits = {
    update: (_mode?: string) => true,
};
